import { memo } from "react";

import type { ForArrayType } from "@/components/features/_model/types/auto-generator-for-view-model";

import { NotificationSettingForEmailForm } from "./components";
import { HELP_CONTENT } from "./constants";

type Props = {
	reservationNotificationEmails: ForArrayType<Array<string>>;
	ecNotificationEmails: ForArrayType<Array<string>>;
	paymentNotificationEmails: ForArrayType<Array<string>>;

	onAppendReservationNotificationEmail: () => void;
	onRemoveReservationNotificationEmail: (index: number) => void;
	onChangeReservationNotificationEmail: (index: number, value: string) => void;
	onAppendEcNotificationEmail: () => void;
	onRemoveEcNotificationEmail: (index: number) => void;
	onChangeEcNotificationEmail: (index: number, value: string) => void;
	onAppendPaymentNotificationEmail: () => void;
	onRemovePaymentNotificationEmail: (index: number) => void;
	onChangePaymentNotificationEmail: (index: number, value: string) => void;
};

export const HotelNotificationSettingsMain = memo(
	({
		reservationNotificationEmails,
		ecNotificationEmails,
		paymentNotificationEmails,

		onAppendReservationNotificationEmail,
		onChangeReservationNotificationEmail,
		onRemoveReservationNotificationEmail,
		onAppendEcNotificationEmail,
		onChangeEcNotificationEmail,
		onRemoveEcNotificationEmail,
		onAppendPaymentNotificationEmail,
		onChangePaymentNotificationEmail,
		onRemovePaymentNotificationEmail,
	}: Props) => {
		return (
			<div className="rounded-lg border border-zinc-100 bg-white p-4 lg:p-12">
				<div className="border-b border-zinc-300 py-8">
					<NotificationSettingForEmailForm
						title="予約"
						helpContent={HELP_CONTENT.reservation}
						sectionIndex={1}
						emails={reservationNotificationEmails.value}
						disabled={reservationNotificationEmails.hasError}
						onAppendEmail={onAppendReservationNotificationEmail}
						onRemoveEmail={onRemoveReservationNotificationEmail}
						onChangeEmail={onChangeReservationNotificationEmail}
					/>
				</div>
				<div className="border-b border-zinc-300 py-8">
					<NotificationSettingForEmailForm
						title="EC"
						helpContent={HELP_CONTENT.ec}
						sectionIndex={2}
						emails={ecNotificationEmails.value}
						disabled={ecNotificationEmails.hasError}
						onAppendEmail={onAppendEcNotificationEmail}
						onRemoveEmail={onRemoveEcNotificationEmail}
						onChangeEmail={onChangeEcNotificationEmail}
					/>
				</div>
				<div className="py-8">
					<NotificationSettingForEmailForm
						title="経理情報"
						helpContent={HELP_CONTENT.payment}
						sectionIndex={3}
						emails={paymentNotificationEmails.value}
						disabled={paymentNotificationEmails.hasError}
						onAppendEmail={onAppendPaymentNotificationEmail}
						onRemoveEmail={onRemovePaymentNotificationEmail}
						onChangeEmail={onChangePaymentNotificationEmail}
					/>
				</div>
			</div>
		);
	},
);
